import React, { useEffect } from "react";
import { Alert, Card, Spin } from "antd";
import { useSearchParams } from "react-router-dom";
import { resolveNewFrontendHref } from "../../../app/navigation/new-frontend-href";

/**
 * 旧合同项地址仍由旧前端先打开，再送到同一份新详情的费用与计价。
 * 不要改挂，也不要写成供应商合同总表下面的子路径。
 */
export default function SupplierContractItemsPage() {
    const [searchParams] = useSearchParams();
    const rawId = searchParams.get("id");
    const contractId = rawId ? Number(rawId) : NaN;
    const valid = Number.isInteger(contractId) && contractId > 0;

    useEffect(() => {
        if (!valid) return;
        window.location.replace(
            resolveNewFrontendHref(`/contract-management/supplier-contracts/detail?id=${contractId}&tab=items`),
        );
    }, [valid, contractId]);

    if (!valid) {
        return (
            <div className="page-container" style={{ padding: 24 }}>
                <Card>
                    <Alert
                        message="打不开这一份合同项"
                        description={(
                            <span>
                                这条地址需要有效的合同编号，也不会落到旧总列表。请回到新的合同总台账，从详情进入费用与计价。
                                {" "}
                                <a href={resolveNewFrontendHref("/contract-management/supplier-contracts")}>返回合同总台账</a>
                            </span>
                        )}
                        type="warning"
                        showIcon
                    />
                </Card>
            </div>
        );
    }

    return (
        <div className="page-container">
            <div style={{ textAlign: "center", padding: 48 }}>
                <Spin />
                <div style={{ marginTop: 12 }}>正在打开费用与计价…</div>
            </div>
        </div>
    );
}
